import { useContext } from "react";
import InglesContext from "../context/InglesProvider";

const useIngles = () => {
    return useContext(InglesContext);
}

export default useIngles;
